import {AppState} from '../../configStore';

export const selectJustAddedDishToShoppingCart = (state: AppState) => state.justAddedDishToShoppingCart;
